<template>
  <div class="overlay" :class="`overlay--${ type }`"/>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'hero',
      validator: propValue => ['hero', 'map'].includes(propValue)
    }
  }
}
</script>

<style lang="scss" scoped>
  .overlay {
    @include full-size(fixed);

    pointer-events: none;
    background-size: 200%;

    @include media-up(sm) {
      background-size: 150%;
    }

    @include media-up(md) {
      background-size: 100%;
    }

    @include media-up(lg) {
      background-size: 75%;
    }

    @include media-up(xl) {
      background-size: 50.15%;
    }

    &--hero {
      background-image: url('/img/overlay-black.png');
    }

    &--map {
      background-image: url('/img/overlay-map.png');
      opacity: .65;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Overlay.vue